!(function () {
    "use strict";
    var t,
        e =
            "undefined" != typeof globalThis
                ? globalThis
                : "undefined" != typeof window
                  ? window
                  : "undefined" != typeof global
                    ? global
                    : "undefined" != typeof self
                      ? self
                      : {},
        i = { exports: {} },
        s = { exports: {} },
        n = { exports: {} };
    (t = n),
        (function (e, i) {
            t.exports ? (t.exports = i()) : (e.EvEmitter = i());
        })("undefined" != typeof window ? window : e, function () {
            function t() {}
            let e = t.prototype;
            return (
                (e.on = function (t, e) {
                    if (!t || !e) return this;
                    let i = (this._events = this._events || {}),
                        s = (i[t] = i[t] || []);
                    return s.includes(e) || s.push(e), this;
                }),
                (e.once = function (t, e) {
                    if (!t || !e) return this;
                    this.on(t, e);
                    let i = (this._onceEvents = this._onceEvents || {});
                    return ((i[t] = i[t] || {})[e] = !0), this;
                }),
                (e.off = function (t, e) {
                    let i = this._events && this._events[t];
                    if (!i || !i.length) return this;
                    let s = i.indexOf(e);
                    return -1 != s && i.splice(s, 1), this;
                }),
                (e.emitEvent = function (t, e) {
                    let i = this._events && this._events[t];
                    if (!i || !i.length) return this;
                    (i = i.slice(0)), (e = e || []);
                    let s = this._onceEvents && this._onceEvents[t];
                    for (let n of i) s && s[n] && (this.off(t, n), delete s[n]), n.apply(this, e);
                    return this;
                }),
                (e.allOff = function () {
                    return delete this._events, delete this._onceEvents, this;
                }),
                t
            );
        });
    var o = { exports: {} };
    /*!
     * Infinite Scroll v2.0.4
     * measure size of elements
     * MIT license
     */ !(function (t) {
        !(function (e, i) {
            t.exports ? (t.exports = i()) : (e.getSize = i());
        })(window, function () {
            function t(t) {
                let e = parseFloat(t);
                return -1 == t.indexOf("%") && !isNaN(e) && e;
            }
            let e = [
                "paddingLeft",
                "paddingRight",
                "paddingTop",
                "paddingBottom",
                "marginLeft",
                "marginRight",
                "marginTop",
                "marginBottom",
                "borderLeftWidth",
                "borderRightWidth",
                "borderTopWidth",
                "borderBottomWidth",
            ];
            return function (i) {
                if (
                    ("string" == typeof i && (i = document.querySelector(i)),
                    !(i && "object" == typeof i && i.nodeType))
                )
                    return;
                let s = getComputedStyle(i);
                if ("none" == s.display)
                    return (function () {
                        let t = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 };
                        return (
                            e.forEach((e) => {
                                t[e] = 0;
                            }),
                            t
                        );
                    })();
                let n = {};
                (n.width = i.offsetWidth), (n.height = i.offsetHeight);
                let o = (n.isBorderBox = "border-box" == s.boxSizing);
                e.forEach((t) => {
                    let e = s[t],
                        i = parseFloat(e);
                    n[t] = isNaN(i) ? 0 : i;
                });
                let r = n.paddingLeft + n.paddingRight,
                    l = n.paddingTop + n.paddingBottom,
                    a = n.marginLeft + n.marginRight,
                    h = n.marginTop + n.marginBottom,
                    c = n.borderLeftWidth + n.borderRightWidth,
                    d = n.borderTopWidth + n.borderBottomWidth,
                    u = t(s.width);
                !1 !== u && (n.width = u + (o ? 0 : r + c));
                let p = t(s.height);
                return (
                    !1 !== p && (n.height = p + (o ? 0 : l + d)),
                    (n.innerWidth = n.width - (r + c)),
                    (n.innerHeight = n.height - (l + d)),
                    (n.outerWidth = n.width + a),
                    (n.outerHeight = n.height + h),
                    n
                );
            };
        });
    })(o);
    var r = { exports: {} };
    !(function (t) {
        !(function (e, i) {
            t.exports ? (t.exports = i(e)) : (e.fizzyUIUtils = i(e));
        })(e, function (t) {
            let e = {
                    extend: function (t, e) {
                        return Object.assign(t, e);
                    },
                    modulo: function (t, e) {
                        return ((t % e) + e) % e;
                    },
                    makeArray: function (t) {
                        if (Array.isArray(t)) return t;
                        if (null == t) return [];
                        return "object" == typeof t && "number" == typeof t.length ? [...t] : [t];
                    },
                    removeFrom: function (t, e) {
                        let i = t.indexOf(e);
                        -1 != i && t.splice(i, 1);
                    },
                    getParent: function (t, e) {
                        for (; t.parentNode && t != document.body; ) if ((t = t.parentNode).matches(e)) return t;
                    },
                    getQueryElement: function (t) {
                        return "string" == typeof t ? document.querySelector(t) : t;
                    },
                    handleEvent: function (t) {
                        let e = "on" + t.type;
                        this[e] && this[e](t);
                    },
                    filterFindElements: function (t, i) {
                        return (t = e.makeArray(t))
                            .filter((t) => t instanceof HTMLElement)
                            .reduce((t, e) => {
                                if (!i) return t.push(e), t;
                                e.matches(i) && t.push(e);
                                let s = e.querySelectorAll(i);
                                return (t = t.concat(...s));
                            }, []);
                    },
                    debounceMethod: function (t, e, i) {
                        i = i || 100;
                        let s = t.prototype[e],
                            n = e + "Timeout";
                        t.prototype[e] = function () {
                            clearTimeout(this[n]);
                            let t = arguments;
                            this[n] = setTimeout(() => {
                                s.apply(this, t), delete this[n];
                            }, i);
                        };
                    },
                    docReady: function (t) {
                        let e = document.readyState;
                        "complete" == e || "interactive" == e
                            ? setTimeout(t)
                            : document.addEventListener("DOMContentLoaded", t);
                    },
                    toDashed: function (t) {
                        return t
                            .replace(/(.)([A-Z])/g, function (t, e, i) {
                                return e + "-" + i;
                            })
                            .toLowerCase();
                    },
                },
                i = t.console;
            return (
                (e.htmlInit = function (s, n) {
                    e.docReady(function () {
                        let o = "data-" + e.toDashed(n),
                            r = document.querySelectorAll(`[${o}]`),
                            l = t.jQuery;
                        [...r].forEach((t) => {
                            let e,
                                r = t.getAttribute(o);
                            try {
                                e = r && JSON.parse(r);
                            } catch (e) {
                                return void (i && i.error(`Error parsing ${o} on ${t.className}: ${e}`));
                            }
                            let a = new s(t, e);
                            l && l.data(t, n, a);
                        });
                    });
                }),
                e
            );
        });
    })(r);
    var l = { exports: {} };
    !(function (t) {
        !(function (e, i) {
            t.exports
                ? (t.exports = i(o.exports))
                : ((e.Flickity = e.Flickity || {}), (e.Flickity.Cell = i(e.getSize)));
        })("undefined" != typeof window ? window : e, function (t) {
            const e = "flickity-cell";
            function i(t) {
                (this.element = t), this.element.classList.add(e), (this.x = 0), this.unselect();
            }
            let s = i.prototype;
            return (
                (s.destroy = function () {
                    this.unselect(),
                        this.element.classList.remove(e),
                        (this.element.style.transform = ""),
                        this.element.removeAttribute("aria-hidden");
                }),
                (s.getSize = function () {
                    this.size = t(this.element);
                }),
                (s.select = function () {
                    this.element.classList.add("is-selected"), this.element.removeAttribute("aria-hidden");
                }),
                (s.unselect = function () {
                    this.element.classList.remove("is-selected"), this.element.setAttribute("aria-hidden", "true");
                }),
                (s.remove = function () {
                    this.element.remove();
                }),
                i
            );
        });
    })(l);
    var a = { exports: {} };
    !(function (t) {
        !(function (e, i) {
            t.exports ? (t.exports = i()) : ((e.Flickity = e.Flickity || {}), (e.Flickity.Slide = i()));
        })("undefined" != typeof window ? window : e, function () {
            function t(t, e, i) {
                (this.beginMargin = t),
                    (this.endMargin = e),
                    (this.cellAlign = i),
                    (this.cells = []),
                    (this.outerWidth = 0),
                    (this.height = 0);
            }
            let e = t.prototype;
            return (
                (e.addCell = function (t) {
                    this.cells.push(t),
                        (this.outerWidth += t.size.outerWidth),
                        (this.height = Math.max(t.size.outerHeight, this.height)),
                        1 === this.cells.length && ((this.x = t.x), (this.firstMargin = t.size[this.beginMargin]));
                }),
                (e.updateTarget = function () {
                    let t = this.getLastCell(),
                        e = t ? t.size[this.endMargin] : 0,
                        i = this.outerWidth - (this.firstMargin + e);
                    this.target = this.x + this.firstMargin + i * this.cellAlign;
                }),
                (e.getLastCell = function () {
                    return this.cells[this.cells.length - 1];
                }),
                (e.select = function () {
                    this.cells.forEach((t) => t.select());
                }),
                (e.unselect = function () {
                    this.cells.forEach((t) => t.unselect());
                }),
                (e.getCellElements = function () {
                    return this.cells.map((t) => t.element);
                }),
                t
            );
        });
    })(a);
    var h = { exports: {} };
    !(function (t) {
        !(function (e, i) {
            t.exports
                ? (t.exports = i(r.exports))
                : ((e.Flickity = e.Flickity || {}), (e.Flickity.animatePrototype = i(e.fizzyUIUtils)));
        })("undefined" != typeof window ? window : e, function (t) {
            let e = {
                startAnimation: function () {
                    this.isAnimating || ((this.isAnimating = !0), (this.restingFrames = 0), this.animate());
                },
                animate: function () {
                    this.applyDragForce(), this.applySelectedAttraction();
                    let t = this.x;
                    this.integratePhysics(),
                        this.positionSlider(),
                        this.settle(t),
                        this.isAnimating && requestAnimationFrame(() => this.animate());
                },
                positionSlider: function () {
                    let e = this.x;
                    this.isWrapping &&
                        ((e = t.modulo(e, this.slideableWidth) - this.slideableWidth), this.shiftWrapCells(e)),
                        this.setTranslateX(e, this.isAnimating),
                        this.dispatchScrollEvent();
                },
                setTranslateX: function (t, e) {
                    (t += this.cursorPosition), this.options.rightToLeft && (t = -t);
                    let i = this.getPositionValue(t);
                    this.slider.style.transform = e ? `translate3d(${i},0,0)` : `translateX(${i})`;
                },
                dispatchScrollEvent: function () {
                    let t = this.slides[0];
                    if (!t) return;
                    let e = -this.x - t.target,
                        i = e / this.slidesWidth;
                    this.dispatchEvent("scroll", null, [i, e]);
                },
                positionSliderAtSelected: function () {
                    this.cells.length &&
                        ((this.x = -this.selectedSlide.target), (this.velocity = 0), this.positionSlider());
                },
                getPositionValue: function (t) {
                    return this.options.percentPosition
                        ? 0.01 * Math.round((t / this.size.innerWidth) * 1e4) + "%"
                        : Math.round(t) + "px";
                },
                settle: function (t) {
                    !this.isPointerDown && Math.round(100 * this.x) === Math.round(100 * t) && this.restingFrames++,
                        this.restingFrames > 2 &&
                            ((this.isAnimating = !1),
                            delete this.isFreeScrolling,
                            this.positionSlider(),
                            this.dispatchEvent("settle", null, [this.selectedIndex]));
                },
                shiftWrapCells: function (t) {
                    let e = this.cursorPosition + t;
                    this._shiftCells(this.beforeShiftCells, e, -1);
                    let i = this.size.innerWidth - (t + this.slideableWidth + this.cursorPosition);
                    this._shiftCells(this.afterShiftCells, i, 1);
                },
                _shiftCells: function (t, e, i) {
                    t.forEach((t) => {
                        let s = e > 0 ? i : 0;
                        this._wrapShiftCell(t, s), (e -= t.size.outerWidth);
                    });
                },
                _unshiftCells: function (t) {
                    t && t.length && t.forEach((t) => this._wrapShiftCell(t, 0));
                },
                _wrapShiftCell: function (t, e) {
                    this._renderCellPosition(t, t.x + this.slideableWidth * e);
                },
                integratePhysics: function () {
                    (this.x += this.velocity), (this.velocity *= this.getFrictionFactor());
                },
                applyForce: function (t) {
                    this.velocity += t;
                },
                getFrictionFactor: function () {
                    return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"];
                },
                getRestingPosition: function () {
                    return this.x + this.velocity / (1 - this.getFrictionFactor());
                },
                applyDragForce: function () {
                    if (!this.isDraggable || !this.isPointerDown) return;
                    let t = this.dragX - this.x - this.velocity;
                    this.applyForce(t);
                },
                applySelectedAttraction: function () {
                    if ((this.isDraggable && this.isPointerDown) || this.isFreeScrolling || !this.slides.length) return;
                    let t = (-1 * this.selectedSlide.target - this.x) * this.options.selectedAttraction;
                    this.applyForce(t);
                },
            };
            return e;
        });
    })(h),
        (function (t) {
            !(function (e, i) {
                if (t.exports) t.exports = i(e, n.exports, o.exports, r.exports, l.exports, a.exports, h.exports);
                else {
                    let t = e.Flickity;
                    e.Flickity = i(e, e.EvEmitter, e.getSize, e.fizzyUIUtils, t.Cell, t.Slide, t.animatePrototype);
                }
            })("undefined" != typeof window ? window : e, function (t, e, i, s, n, o, r) {
                const { getComputedStyle: l, console: a } = t;
                let { jQuery: h } = t,
                    c = 0,
                    d = {};
                function u(t, e) {
                    let i = s.getQueryElement(t);
                    if (i) {
                        if (((this.element = i), this.element.flickityGUID)) {
                            let t = d[this.element.flickityGUID];
                            return t && t.option(e), t;
                        }
                        h && (this.$element = h(this.element)),
                            (this.options = { ...this.constructor.defaults }),
                            this.option(e),
                            this._create();
                    } else a && a.error(`Bad element for Flickity: ${i || t}`);
                }
                (u.defaults = {
                    accessibility: !0,
                    cellAlign: "center",
                    freeScrollFriction: 0.075,
                    friction: 0.28,
                    namespaceJQueryEvents: !0,
                    percentPosition: !0,
                    resize: !0,
                    selectedAttraction: 0.025,
                    setGallerySize: !0,
                }),
                    (u.create = {});
                let p = u.prototype;
                Object.assign(p, e.prototype),
                    (p._create = function () {
                        let { resize: e, watchCSS: i, rightToLeft: s } = this.options,
                            n = (this.guid = ++c);
                        (this.element.flickityGUID = n),
                            (d[n] = this),
                            (this.selectedIndex = 0),
                            (this.restingFrames = 0),
                            (this.x = 0),
                            (this.velocity = 0),
                            (this.beginMargin = s ? "marginRight" : "marginLeft"),
                            (this.endMargin = s ? "marginLeft" : "marginRight"),
                            (this.viewport = document.createElement("div")),
                            (this.viewport.className = "flickity-viewport"),
                            this._createSlider(),
                            (this.focusableElems = [this.element]),
                            (e || i) && t.addEventListener("resize", this);
                        for (let t in this.options.on) {
                            let e = this.options.on[t];
                            this.on(t, e);
                        }
                        for (let t in u.create) u.create[t].call(this);
                        i ? this.watchCSS() : this.activate();
                    }),
                    (p.option = function (t) {
                        Object.assign(this.options, t);
                    }),
                    (p.activate = function () {
                        if (this.isActive) return;
                        (this.isActive = !0),
                            this.element.classList.add("flickity-enabled"),
                            this.options.rightToLeft && this.element.classList.add("flickity-rtl"),
                            this.getSize();
                        let t = this._filterFindCellElements(this.element.children);
                        this.slider.append(...t),
                            this.viewport.append(this.slider),
                            this.element.append(this.viewport),
                            this.reloadCells(),
                            this.options.accessibility &&
                                ((this.element.tabIndex = 0), this.element.addEventListener("keydown", this)),
                            this.emitEvent("activate"),
                            this.selectInitialIndex(),
                            (this.isInitActivated = !0),
                            this.dispatchEvent("ready");
                    }),
                    (p._createSlider = function () {
                        let t = document.createElement("div");
                        (t.className = "flickity-slider"), (this.slider = t);
                    }),
                    (p._filterFindCellElements = function (t) {
                        return s.filterFindElements(t, this.options.cellSelector);
                    }),
                    (p.reloadCells = function () {
                        (this.cells = this._makeCells(this.slider.children)),
                            this.positionCells(),
                            this._updateWrapShiftCells(),
                            this.setGallerySize();
                    }),
                    (p._makeCells = function (t) {
                        return this._filterFindCellElements(t).map((t) => new n(t));
                    }),
                    (p.getLastCell = function () {
                        return this.cells[this.cells.length - 1];
                    }),
                    (p.getLastSlide = function () {
                        return this.slides[this.slides.length - 1];
                    }),
                    (p.positionCells = function () {
                        this._sizeCells(this.cells), this._positionCells(0);
                    }),
                    (p._positionCells = function (t) {
                        (t = t || 0), (this.maxCellHeight = (t && this.maxCellHeight) || 0);
                        let e = 0;
                        if (t > 0) {
                            let i = this.cells[t - 1];
                            e = i.x + i.size.outerWidth;
                        }
                        this.cells.slice(t).forEach((t) => {
                            (t.x = e),
                                this._renderCellPosition(t, e),
                                (e += t.size.outerWidth),
                                (this.maxCellHeight = Math.max(t.size.outerHeight, this.maxCellHeight));
                        }),
                            (this.slideableWidth = e),
                            this.updateSlides(),
                            this._containSlides(),
                            (this.slidesWidth = this.cells.length
                                ? this.getLastSlide().target - this.slides[0].target
                                : 0);
                    }),
                    (p._renderCellPosition = function (t, e) {
                        let i = e * (this.options.rightToLeft ? -1 : 1);
                        this.options.percentPosition && (i *= this.size.innerWidth / t.size.width);
                        let s = this.getPositionValue(i);
                        t.element.style.transform = `translateX( ${s} )`;
                    }),
                    (p._sizeCells = function (t) {
                        t.forEach((t) => t.getSize());
                    }),
                    (p.updateSlides = function () {
                        if (((this.slides = []), !this.cells.length)) return;
                        let { beginMargin: t, endMargin: e } = this,
                            i = new o(t, e, this.cellAlign);
                        this.slides.push(i);
                        let s = this._getCanCellFit();
                        this.cells.forEach((n, r) => {
                            if (!i.cells.length) return void i.addCell(n);
                            let l = i.outerWidth - i.firstMargin + (n.size.outerWidth - n.size[e]);
                            s(r, l) || (i.updateTarget(), (i = new o(t, e, this.cellAlign)), this.slides.push(i)),
                                i.addCell(n);
                        }),
                            i.updateTarget(),
                            this.updateSelectedSlide();
                    }),
                    (p._getCanCellFit = function () {
                        let { groupCells: t } = this.options;
                        if (!t) return () => !1;
                        if ("number" == typeof t) {
                            let e = parseInt(t, 10);
                            return (t) => t % e !== 0;
                        }
                        let e = 1,
                            i = "string" == typeof t && t.match(/^(\d+)%$/);
                        i && (e = parseInt(i[1], 10) / 100);
                        let s = (this.size.innerWidth + 1) * e;
                        return (t, e) => e <= s;
                    }),
                    (p._init = p.reposition =
                        function () {
                            this.positionCells(), this.positionSliderAtSelected();
                        }),
                    (p.getSize = function () {
                        (this.size = i(this.element)),
                            this.setCellAlign(),
                            (this.cursorPosition = this.size.innerWidth * this.cellAlign);
                    });
                let f = { left: 0, center: 0.5, right: 1 };
                (p.setCellAlign = function () {
                    let { cellAlign: t, rightToLeft: e } = this.options,
                        i = f[t];
                    (this.cellAlign = void 0 !== i ? i : t), e && (this.cellAlign = 1 - this.cellAlign);
                }),
                    (p.setGallerySize = function () {
                        if (!this.options.setGallerySize) return;
                        let t =
                            this.options.adaptiveHeight && this.selectedSlide
                                ? this.selectedSlide.height
                                : this.maxCellHeight;
                        this.viewport.style.height = `${t}px`;
                    }),
                    (p._updateWrapShiftCells = function () {
                        if (((this.isWrapping = this.getIsWrapping()), !this.isWrapping)) return;
                        this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
                        let t = this.cursorPosition,
                            e = this.cells.length - 1;
                        this.beforeShiftCells = this._getGapCells(t, e, -1);
                        let i = this.size.innerWidth - this.cursorPosition;
                        this.afterShiftCells = this._getGapCells(i, 0, 1);
                    }),
                    (p.getIsWrapping = function () {
                        let { wrapAround: t } = this.options;
                        if (!t || this.slides.length < 2) return !1;
                        if ("fill" !== t) return !0;
                        let e = this.slideableWidth - this.size.innerWidth;
                        if (e > this.size.innerWidth) return !0;
                        for (let t of this.cells) if (t.size.outerWidth > e) return !1;
                        return !0;
                    }),
                    (p._getGapCells = function (t, e, i) {
                        let s = [];
                        for (; t > 0; ) {
                            let n = this.cells[e];
                            if (!n) break;
                            s.push(n), (e += i), (t -= n.size.outerWidth);
                        }
                        return s;
                    }),
                    (p._containSlides = function () {
                        if (!(this.options.contain && !this.isWrapping && this.cells.length)) return;
                        let t = this.slideableWidth - this.getLastCell().size[this.endMargin];
                        if (t < this.size.innerWidth)
                            this.slides.forEach((e) => {
                                e.target = t * this.cellAlign;
                            });
                        else {
                            let e = this.cursorPosition + this.cells[0].size[this.beginMargin],
                                i = t - this.size.innerWidth * (1 - this.cellAlign);
                            this.slides.forEach((t) => {
                                (t.target = Math.max(t.target, e)), (t.target = Math.min(t.target, i));
                            });
                        }
                    }),
                    (p.dispatchEvent = function (t, e, i) {
                        let s = e ? [e].concat(i) : i;
                        if ((this.emitEvent(t, s), h && this.$element)) {
                            let s = (t += this.options.namespaceJQueryEvents ? ".flickity" : "");
                            if (e) {
                                let i = new h.Event(e);
                                (i.type = t), (s = i);
                            }
                            this.$element.trigger(s, i);
                        }
                    });
                const m = [
                    "dragStart",
                    "dragMove",
                    "dragEnd",
                    "pointerDown",
                    "pointerMove",
                    "pointerEnd",
                    "staticClick",
                ];
                let g = p.emitEvent;
                (p.emitEvent = function (t, e) {
                    if ("staticClick" === t) {
                        let t = this.getParentCell(e[0].target),
                            i = t && t.element,
                            s = t && this.cells.indexOf(t);
                        e = e.concat(i, s);
                    }
                    if ((g.call(this, t, e), !m.includes(t) || !h || !this.$element)) return;
                    t += this.options.namespaceJQueryEvents ? ".flickity" : "";
                    let i = e.shift(0),
                        s = new h.Event(i);
                    (s.type = t), this.$element.trigger(s, e);
                }),
                    (p.select = function (t, e, i) {
                        if (!this.isActive) return;
                        if (
                            ((t = parseInt(t, 10)),
                            this._wrapSelect(t),
                            (this.isWrapping || e) && (t = s.modulo(t, this.slides.length)),
                            !this.slides[t])
                        )
                            return;
                        let n = this.selectedIndex;
                        (this.selectedIndex = t),
                            this.updateSelectedSlide(),
                            i ? this.positionSliderAtSelected() : this.startAnimation(),
                            this.options.adaptiveHeight && this.setGallerySize(),
                            this.dispatchEvent("select", null, [t]),
                            t !== n && this.dispatchEvent("change", null, [t]);
                    }),
                    (p._wrapSelect = function (t) {
                        if (!this.isWrapping) return;
                        const {
                            selectedIndex: e,
                            slideableWidth: i,
                            slides: { length: n },
                        } = this;
                        if (!this.isDragSelect) {
                            let i = s.modulo(t, n),
                                o = Math.abs(i - e),
                                r = Math.abs(i + n - e),
                                l = Math.abs(i - n - e);
                            r < o ? (t += n) : l < o && (t -= n);
                        }
                        t < 0 ? (this.x -= i) : t >= n && (this.x += i);
                    }),
                    (p.previous = function (t, e) {
                        this.select(this.selectedIndex - 1, t, e);
                    }),
                    (p.next = function (t, e) {
                        this.select(this.selectedIndex + 1, t, e);
                    }),
                    (p.updateSelectedSlide = function () {
                        let t = this.slides[this.selectedIndex];
                        t &&
                            (this.unselectSelectedSlide(),
                            (this.selectedSlide = t),
                            t.select(),
                            (this.selectedCells = t.cells),
                            (this.selectedElements = t.getCellElements()),
                            (this.selectedCell = t.cells[0]),
                            (this.selectedElement = this.selectedElements[0]));
                    }),
                    (p.unselectSelectedSlide = function () {
                        this.selectedSlide && this.selectedSlide.unselect();
                    }),
                    (p.selectInitialIndex = function () {
                        let t = this.options.initialIndex;
                        if (this.isInitActivated) return void this.select(this.selectedIndex, !1, !0);
                        if (t && "string" == typeof t) {
                            if (this.queryCell(t)) return void this.selectCell(t, !1, !0);
                        }
                        let e = 0;
                        t && this.slides[t] && (e = t), this.select(e, !1, !0);
                    }),
                    (p.selectCell = function (t, e, i) {
                        let s = this.queryCell(t);
                        if (!s) return;
                        let n = this.getCellSlideIndex(s);
                        this.select(n, e, i);
                    }),
                    (p.getCellSlideIndex = function (t) {
                        let e = this.slides.find((e) => e.cells.includes(t));
                        return this.slides.indexOf(e);
                    }),
                    (p.getCell = function (t) {
                        for (let e of this.cells) if (e.element === t) return e;
                    }),
                    (p.getCells = function (t) {
                        return (t = s.makeArray(t)).map((t) => this.getCell(t)).filter(Boolean);
                    }),
                    (p.getCellElements = function () {
                        return this.cells.map((t) => t.element);
                    }),
                    (p.getParentCell = function (t) {
                        let e = this.getCell(t);
                        if (e) return e;
                        let i = t.closest(".flickity-slider > *");
                        return this.getCell(i);
                    }),
                    (p.getAdjacentCellElements = function (t, e) {
                        if (!t) return this.selectedSlide.getCellElements();
                        e = void 0 === e ? this.selectedIndex : e;
                        let i = this.slides.length;
                        if (1 + 2 * t >= i) return this.getCellElements();
                        let n = [];
                        for (let o = e - t; o <= e + t; o++) {
                            let t = this.isWrapping ? s.modulo(o, i) : o,
                                e = this.slides[t];
                            e && (n = n.concat(e.getCellElements()));
                        }
                        return n;
                    }),
                    (p.queryCell = function (t) {
                        if ("number" == typeof t) return this.cells[t];
                        return (
                            "string" == typeof t && !t.match(/^[#.]?[\d/]/) && (t = this.element.querySelector(t)),
                            this.getCell(t)
                        );
                    }),
                    (p.uiChange = function () {
                        this.emitEvent("uiChange");
                    }),
                    (p.onresize = function () {
                        this.watchCSS(), this.resize();
                    }),
                    s.debounceMethod(u, "onresize", 150),
                    (p.resize = function () {
                        if (!this.isActive || this.isAnimating || this.isDragging) return;
                        this.getSize(),
                            this.isWrapping && (this.x = s.modulo(this.x, this.slideableWidth)),
                            this.positionCells(),
                            this._updateWrapShiftCells(),
                            this.setGallerySize(),
                            this.emitEvent("resize");
                        let t = this.selectedElements && this.selectedElements[0];
                        this.selectCell(t, !1, !0);
                    }),
                    (p.watchCSS = function () {
                        if (!this.options.watchCSS) return;
                        l(this.element, ":after").content.includes("flickity") ? this.activate() : this.deactivate();
                    }),
                    (p.onkeydown = function (t) {
                        let { activeElement: e } = document,
                            i = u.keyboardHandlers[t.key];
                        this.options.accessibility &&
                            e &&
                            i &&
                            this.focusableElems.some((t) => e === t) &&
                            i.call(this);
                    }),
                    (u.keyboardHandlers = {
                        ArrowLeft: function () {
                            this.uiChange(), this[this.options.rightToLeft ? "next" : "previous"]();
                        },
                        ArrowRight: function () {
                            this.uiChange(), this[this.options.rightToLeft ? "previous" : "next"]();
                        },
                    }),
                    (p.focus = function () {
                        this.element.focus({ preventScroll: !0 });
                    }),
                    (p.deactivate = function () {
                        this.isActive &&
                            (this.element.classList.remove("flickity-enabled"),
                            this.element.classList.remove("flickity-rtl"),
                            this.unselectSelectedSlide(),
                            this.cells.forEach((t) => t.destroy()),
                            this.viewport.remove(),
                            this.element.append(...this.slider.children),
                            this.options.accessibility &&
                                (this.element.removeAttribute("tabIndex"),
                                this.element.removeEventListener("keydown", this)),
                            (this.isActive = !1),
                            this.emitEvent("deactivate"));
                    }),
                    (p.destroy = function () {
                        this.deactivate(),
                            t.removeEventListener("resize", this),
                            this.allOff(),
                            this.emitEvent("destroy"),
                            h && this.$element && h.removeData(this.element, "flickity"),
                            delete this.element.flickityGUID,
                            delete d[this.guid];
                    }),
                    Object.assign(p, r),
                    (u.data = function (t) {
                        if ((t = s.getQueryElement(t))) return d[t.flickityGUID];
                    }),
                    s.htmlInit(u, "flickity");
                let { jQueryBridget: v } = t;
                return (
                    h && v && v("flickity", u, h),
                    (u.setJQuery = function (t) {
                        h = t;
                    }),
                    (u.Cell = n),
                    (u.Slide = o),
                    u
                );
            });
        })(s);
    var c = { exports: {} };
    /*!
     * Unidragger v3.0.1
     * Draggable base class
     * MIT license
     */
    !(function (t) {
        !(function (e, i) {
            t.exports ? (t.exports = i(e, n.exports)) : (e.Unidragger = i(e, e.EvEmitter));
        })("undefined" != typeof window ? window : e, function (t, e) {
            function i() {}
            let s,
                n,
                o = (i.prototype = Object.create(e.prototype));
            (o.handleEvent = function (t) {
                let e = "on" + t.type;
                this[e] && this[e](t);
            }),
                "ontouchstart" in t
                    ? ((s = "touchstart"), (n = ["touchmove", "touchend", "touchcancel"]))
                    : t.PointerEvent
                      ? ((s = "pointerdown"), (n = ["pointermove", "pointerup", "pointercancel"]))
                      : ((s = "mousedown"), (n = ["mousemove", "mouseup"])),
                (o.touchActionValue = "none"),
                (o.bindHandles = function () {
                    this._bindHandles("addEventListener", this.touchActionValue);
                }),
                (o.unbindHandles = function () {
                    this._bindHandles("removeEventListener", "");
                }),
                (o._bindHandles = function (e, i) {
                    this.handles.forEach((n) => {
                        n[e](s, this), n[e]("click", this), t.PointerEvent && (n.style.touchAction = i);
                    });
                }),
                (o.bindActivePointerEvents = function () {
                    n.forEach((e) => {
                        t.addEventListener(e, this);
                    });
                }),
                (o.unbindActivePointerEvents = function () {
                    n.forEach((e) => {
                        t.removeEventListener(e, this);
                    });
                }),
                (o.withPointer = function (t, e) {
                    e.pointerId === this.pointerIdentifier && this[t](e, e);
                }),
                (o.withTouch = function (t, e) {
                    let i;
                    for (let t of e.changedTouches) t.identifier === this.pointerIdentifier && (i = t);
                    i && this[t](e, i);
                }),
                (o.onmousedown = function (t) {
                    this.pointerDown(t, t);
                }),
                (o.ontouchstart = function (t) {
                    this.pointerDown(t, t.changedTouches[0]);
                }),
                (o.onpointerdown = function (t) {
                    this.pointerDown(t, t);
                });
            const r = ["TEXTAREA", "INPUT", "SELECT", "OPTION"],
                l = ["radio", "checkbox", "button", "submit", "image", "file"];
            return (
                (o.pointerDown = function (t, e) {
                    let i = r.includes(t.target.nodeName),
                        s = l.includes(t.target.type),
                        n = !i || s;
                    !this.isPointerDown &&
                        !t.button &&
                        n &&
                        ((this.isPointerDown = !0),
                        (this.pointerIdentifier = void 0 !== e.pointerId ? e.pointerId : e.identifier),
                        (this.pointerDownPointer = { pageX: e.pageX, pageY: e.pageY }),
                        this.bindActivePointerEvents(),
                        this.emitEvent("pointerDown", [t, e]));
                }),
                (o.onmousemove = function (t) {
                    this.pointerMove(t, t);
                }),
                (o.onpointermove = function (t) {
                    this.withPointer("pointerMove", t);
                }),
                (o.ontouchmove = function (t) {
                    this.withTouch("pointerMove", t);
                }),
                (o.pointerMove = function (t, e) {
                    let i = { x: e.pageX - this.pointerDownPointer.pageX, y: e.pageY - this.pointerDownPointer.pageY };
                    this.emitEvent("pointerMove", [t, e, i]),
                        !this.isDragging && this.hasDragStarted(i) && this.dragStart(t, e),
                        this.isDragging && this.dragMove(t, e, i);
                }),
                (o.hasDragStarted = function (t) {
                    return Math.abs(t.x) > 3 || Math.abs(t.y) > 3;
                }),
                (o.dragStart = function (t, e) {
                    (this.isDragging = !0), (this.isPreventingClicks = !0), this.emitEvent("dragStart", [t, e]);
                }),
                (o.dragMove = function (t, e, i) {
                    this.emitEvent("dragMove", [t, e, i]);
                }),
                (o.onmouseup = function (t) {
                    this.pointerUp(t, t);
                }),
                (o.onpointerup = function (t) {
                    this.withPointer("pointerUp", t);
                }),
                (o.ontouchend = function (t) {
                    this.withTouch("pointerUp", t);
                }),
                (o.pointerUp = function (t, e) {
                    this.pointerDone(),
                        this.emitEvent("pointerUp", [t, e]),
                        this.isDragging ? this.dragEnd(t, e) : this.staticClick(t, e);
                }),
                (o.dragEnd = function (t, e) {
                    (this.isDragging = !1),
                        setTimeout(() => delete this.isPreventingClicks),
                        this.emitEvent("dragEnd", [t, e]);
                }),
                (o.pointerDone = function () {
                    (this.isPointerDown = !1),
                        delete this.pointerIdentifier,
                        this.unbindActivePointerEvents(),
                        this.emitEvent("pointerDone");
                }),
                (o.onpointercancel = function (t) {
                    this.withPointer("pointerCancel", t);
                }),
                (o.ontouchcancel = function (t) {
                    this.withTouch("pointerCancel", t);
                }),
                (o.pointerCancel = function (t, e) {
                    this.pointerDone(), this.emitEvent("pointerCancel", [t, e]);
                }),
                (o.onclick = function (t) {
                    this.isPreventingClicks && t.preventDefault();
                }),
                (o.staticClick = function (t, e) {
                    let i = "mouseup" === t.type;
                    (i && this.isIgnoringMouseUp) ||
                        (this.emitEvent("staticClick", [t, e]),
                        i &&
                            ((this.isIgnoringMouseUp = !0),
                            setTimeout(() => {
                                delete this.isIgnoringMouseUp;
                            }, 400)));
                }),
                i
            );
        });
    })(c),
        (function (t) {
            !(function (e, i) {
                t.exports
                    ? (t.exports = i(e, s.exports, c.exports, r.exports))
                    : (e.Flickity = i(e, e.Flickity, e.Unidragger, e.fizzyUIUtils));
            })("undefined" != typeof window ? window : e, function (t, e, i, s) {
                Object.assign(e.defaults, { draggable: ">1", dragThreshold: 3 });
                let n = e.prototype;
                function o() {
                    return { x: t.pageXOffset, y: t.pageYOffset };
                }
                return (
                    Object.assign(n, i.prototype),
                    (n.touchActionValue = ""),
                    (e.create.drag = function () {
                        this.on("activate", this.onActivateDrag),
                            this.on("uiChange", this._uiChangeDrag),
                            this.on("deactivate", this.onDeactivateDrag),
                            this.on("cellChange", this.updateDraggable),
                            this.on("pointerDown", this.handlePointerDown),
                            this.on("pointerUp", this.handlePointerUp),
                            this.on("pointerDown", this.handlePointerDone),
                            this.on("dragStart", this.handleDragStart),
                            this.on("dragMove", this.handleDragMove),
                            this.on("dragEnd", this.handleDragEnd),
                            this.on("staticClick", this.handleStaticClick);
                    }),
                    (n.onActivateDrag = function () {
                        (this.handles = [this.viewport]), this.bindHandles(), this.updateDraggable();
                    }),
                    (n.onDeactivateDrag = function () {
                        this.unbindHandles(), this.element.classList.remove("is-draggable");
                    }),
                    (n.updateDraggable = function () {
                        ">1" === this.options.draggable
                            ? (this.isDraggable = this.slides.length > 1)
                            : (this.isDraggable = this.options.draggable),
                            this.element.classList.toggle("is-draggable", this.isDraggable);
                    }),
                    (n._uiChangeDrag = function () {
                        delete this.isFreeScrolling;
                    }),
                    (n.handlePointerDown = function (e) {
                        if (!this.isDraggable) return void this.bindActivePointerEvents(e);
                        let i = "touchstart" === e.type,
                            s = "touch" === e.pointerType,
                            n = e.target.matches("input, textarea, select");
                        i || s || n || e.preventDefault(),
                            n || this.focus(),
                            document.activeElement !== this.element && document.activeElement.blur(),
                            (this.dragX = this.x),
                            this.viewport.classList.add("is-pointer-down"),
                            (this.pointerDownScroll = o()),
                            t.addEventListener("scroll", this),
                            this.bindActivePointerEvents(e);
                    }),
                    (n.hasDragStarted = function (t) {
                        return Math.abs(t.x) > this.options.dragThreshold;
                    }),
                    (n.handlePointerUp = function () {
                        delete this.isTouchScrolling, this.viewport.classList.remove("is-pointer-down");
                    }),
                    (n.handlePointerDone = function () {
                        t.removeEventListener("scroll", this), delete this.pointerDownScroll;
                    }),
                    (n.handleDragStart = function () {
                        this.isDraggable &&
                            ((this.dragStartPosition = this.x),
                            this.startAnimation(),
                            t.removeEventListener("scroll", this));
                    }),
                    (n.handleDragMove = function (t, e, i) {
                        if (!this.isDraggable) return;
                        t.preventDefault(), (this.previousDragX = this.dragX);
                        let s = this.options.rightToLeft ? -1 : 1;
                        this.isWrapping && (i.x %= this.slideableWidth);
                        let n = this.dragStartPosition + i.x * s;
                        if (!this.isWrapping) {
                            let t = Math.max(-this.slides[0].target, this.dragStartPosition);
                            n = n > t ? 0.5 * (n + t) : n;
                            let e = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                            n = n < e ? 0.5 * (n + e) : n;
                        }
                        (this.dragX = n), (this.dragMoveTime = new Date());
                    }),
                    (n.handleDragEnd = function () {
                        if (!this.isDraggable) return;
                        let { freeScroll: t } = this.options;
                        t && (this.isFreeScrolling = !0);
                        let e = this.dragEndRestingSelect();
                        if (t && !this.isWrapping) {
                            let t = this.getRestingPosition();
                            this.isFreeScrolling = -t > this.slides[0].target && -t < this.getLastSlide().target;
                        } else t || e !== this.selectedIndex || (e += this.dragEndBoostSelect());
                        delete this.previousDragX,
                            (this.isDragSelect = this.isWrapping),
                            this.select(e),
                            delete this.isDragSelect;
                    }),
                    (n.dragEndRestingSelect = function () {
                        let t = this.getRestingPosition(),
                            e = Math.abs(this.getSlideDistance(-t, this.selectedIndex)),
                            i = this._getClosestResting(t, e, 1),
                            s = this._getClosestResting(t, e, -1);
                        return i.distance < s.distance ? i.index : s.index;
                    }),
                    (n._getClosestResting = function (t, e, i) {
                        let s = this.selectedIndex,
                            n = 1 / 0,
                            o = this.options.contain && !this.isWrapping ? (t, e) => t <= e : (t, e) => t < e;
                        for (; o(e, n) && ((s += i), (n = e), null !== (e = this.getSlideDistance(-t, s))); )
                            e = Math.abs(e);
                        return { distance: n, index: s - i };
                    }),
                    (n.getSlideDistance = function (t, e) {
                        let i = this.slides.length,
                            n = this.options.wrapAround && i > 1,
                            o = n ? s.modulo(e, i) : e,
                            r = this.slides[o];
                        if (!r) return null;
                        let l = n ? this.slideableWidth * Math.floor(e / i) : 0;
                        return t - (r.target + l);
                    }),
                    (n.dragEndBoostSelect = function () {
                        if (void 0 === this.previousDragX || !this.dragMoveTime || new Date() - this.dragMoveTime > 100)
                            return 0;
                        let t = this.getSlideDistance(-this.dragX, this.selectedIndex),
                            e = this.previousDragX - this.dragX;
                        return t > 0 && e > 0 ? 1 : t < 0 && e < 0 ? -1 : 0;
                    }),
                    (n.onscroll = function () {
                        let t = o(),
                            e = this.pointerDownScroll.x - t.x,
                            i = this.pointerDownScroll.y - t.y;
                        (Math.abs(e) > 3 || Math.abs(i) > 3) && this.pointerDone();
                    }),
                    e
                );
            });
        })({ exports: {} });
    !(function (t) {
        !(function (e, i) {
            t.exports ? (t.exports = i(s.exports)) : i(e.Flickity);
        })("undefined" != typeof window ? window : e, function (t) {
            const e = "http://www.w3.org/2000/svg";
            function i(t, e, i) {
                (this.increment = t),
                    (this.direction = e),
                    (this.isPrevious = "previous" === t),
                    (this.isLeft = "left" === e),
                    this._create(i);
            }
            (i.prototype._create = function (t) {
                let e = (this.element = document.createElement("button"));
                e.className = `flickity-button flickity-prev-next-button ${this.increment}`;
                let i = this.isPrevious ? "Previous" : "Next";
                e.setAttribute("type", "button"), e.setAttribute("aria-label", i), this.disable();
                let s = this.createSVG(i, t);
                e.append(s);
            }),
                (i.prototype.createSVG = function (t, i) {
                    let s = document.createElementNS(e, "svg");
                    s.setAttribute("class", "flickity-button-icon"), s.setAttribute("viewBox", "0 0 100 100");
                    let n = document.createElementNS(e, "title");
                    n.append(t);
                    let o = document.createElementNS(e, "path"),
                        r = (function (t) {
                            if ("string" == typeof t) return t;
                            let { x0: e, x1: i, x2: s, x3: n, y1: o, y2: r } = t;
                            return `M ${e}, 50\n    L ${i}, ${o + 50}\n    L ${s}, ${r + 50}\n    L ${n}, 50\n    L ${s}, ${50 - r}\n    L ${i}, ${50 - o}\n    Z`;
                        })(i);
                    return (
                        o.setAttribute("d", r),
                        o.setAttribute("class", "arrow"),
                        this.isLeft || o.setAttribute("transform", "translate(100, 100) rotate(180)"),
                        s.append(n, o),
                        s
                    );
                }),
                (i.prototype.enable = function () {
                    this.element.removeAttribute("disabled");
                }),
                (i.prototype.disable = function () {
                    this.element.setAttribute("disabled", !0);
                }),
                Object.assign(t.defaults, {
                    prevNextButtons: !0,
                    arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 },
                }),
                (t.create.prevNextButtons = function () {
                    if (!this.options.prevNextButtons) return;
                    let { rightToLeft: t, arrowShape: e } = this.options,
                        s = t ? "right" : "left",
                        n = t ? "left" : "right";
                    (this.prevButton = new i("previous", s, e)),
                        (this.nextButton = new i("next", n, e)),
                        this.focusableElems.push(this.prevButton.element),
                        this.focusableElems.push(this.nextButton.element),
                        (this.handlePrevButtonClick = () => {
                            this.uiChange(), this.previous();
                        }),
                        (this.handleNextButtonClick = () => {
                            this.uiChange(), this.next();
                        }),
                        this.on("activate", this.activatePrevNextButtons),
                        this.on("select", this.updatePrevNextButtons);
                });
            let s = t.prototype;
            return (
                (s.updatePrevNextButtons = function () {
                    let t = this.slides.length ? this.slides.length - 1 : 0;
                    this.updatePrevNextButton(this.prevButton, 0), this.updatePrevNextButton(this.nextButton, t);
                }),
                (s.updatePrevNextButton = function (t, e) {
                    if (this.isWrapping && this.slides.length > 1) return void t.enable();
                    let i = this.selectedIndex !== e;
                    t[i ? "enable" : "disable"](), !i && document.activeElement === t.element && this.focus();
                }),
                (s.activatePrevNextButtons = function () {
                    this.prevButton.element.addEventListener("click", this.handlePrevButtonClick),
                        this.nextButton.element.addEventListener("click", this.handleNextButtonClick),
                        this.element.append(this.prevButton.element, this.nextButton.element),
                        this.on("deactivate", this.deactivatePrevNextButtons);
                }),
                (s.deactivatePrevNextButtons = function () {
                    this.prevButton.element.remove(),
                        this.nextButton.element.remove(),
                        this.prevButton.element.removeEventListener("click", this.handlePrevButtonClick),
                        this.nextButton.element.removeEventListener("click", this.handleNextButtonClick),
                        this.off("deactivate", this.deactivatePrevNextButtons);
                }),
                (t.PrevNextButton = i),
                t
            );
        });
    })({ exports: {} });
    !(function (t) {
        !(function (e, i) {
            t.exports ? (t.exports = i(s.exports, r.exports)) : i(e.Flickity, e.fizzyUIUtils);
        })("undefined" != typeof window ? window : e, function (t, e) {
            function i() {
                (this.holder = document.createElement("div")),
                    (this.holder.className = "flickity-page-dots"),
                    (this.dots = []);
            }
            (i.prototype.setDots = function (t) {
                let e = t - this.dots.length;
                e > 0 ? this.addDots(e) : e < 0 && this.removeDots(-e);
            }),
                (i.prototype.addDots = function (t) {
                    let e = new Array(t).fill().map((t, e) => {
                        let i = document.createElement("button");
                        i.setAttribute("type", "button");
                        let s = e + 1 + this.dots.length;
                        return (i.className = "flickity-page-dot"), (i.textContent = `View slide ${s}`), i;
                    });
                    this.holder.append(...e), (this.dots = this.dots.concat(e));
                }),
                (i.prototype.removeDots = function (t) {
                    this.dots.splice(this.dots.length - t, t).forEach((t) => t.remove());
                }),
                (i.prototype.updateSelected = function (t) {
                    this.selectedDot &&
                        (this.selectedDot.classList.remove("is-selected"),
                        this.selectedDot.removeAttribute("aria-current")),
                        this.dots.length &&
                            ((this.selectedDot = this.dots[t]),
                            this.selectedDot.classList.add("is-selected"),
                            this.selectedDot.setAttribute("aria-current", "step"));
                }),
                (t.PageDots = i),
                Object.assign(t.defaults, { pageDots: !0 }),
                (t.create.pageDots = function () {
                    this.options.pageDots &&
                        ((this.pageDots = new i()),
                        (this.handlePageDotsClick = this.onPageDotsClick.bind(this)),
                        this.on("activate", this.activatePageDots),
                        this.on("select", this.updateSelectedPageDots),
                        this.on("cellChange", this.updatePageDots),
                        this.on("resize", this.updatePageDots),
                        this.on("deactivate", this.deactivatePageDots));
                });
            let s = t.prototype;
            return (
                (s.activatePageDots = function () {
                    this.pageDots.setDots(this.slides.length),
                        this.focusableElems.push(...this.pageDots.dots),
                        this.pageDots.holder.addEventListener("click", this.handlePageDotsClick),
                        this.element.append(this.pageDots.holder);
                }),
                (s.onPageDotsClick = function (t) {
                    let e = this.pageDots.dots.indexOf(t.target);
                    -1 !== e && (this.uiChange(), this.select(e));
                }),
                (s.updateSelectedPageDots = function () {
                    this.pageDots.updateSelected(this.selectedIndex);
                }),
                (s.updatePageDots = function () {
                    this.pageDots.dots.forEach((t) => {
                        e.removeFrom(this.focusableElems, t);
                    }),
                        this.pageDots.setDots(this.slides.length),
                        this.focusableElems.push(...this.pageDots.dots);
                }),
                (s.deactivatePageDots = function () {
                    this.pageDots.holder.remove(),
                        this.pageDots.holder.removeEventListener("click", this.handlePageDotsClick);
                }),
                (t.PageDots = i),
                t
            );
        });
    })({ exports: {} });
    !(function (t) {
        !(function (e, i) {
            t.exports ? (t.exports = i(s.exports)) : i(e.Flickity);
        })("undefined" != typeof window ? window : e, function (t) {
            function e(t, e) {
                (this.autoPlay = t),
                    (this.onTick = e),
                    (this.state = "stopped"),
                    (this.onVisibilityChange = this.visibilityChange.bind(this)),
                    (this.onVisibilityPlay = this.visibilityPlay.bind(this));
            }
            (e.prototype.play = function () {
                if ("playing" === this.state) return;
                document.hidden
                    ? document.addEventListener("visibilitychange", this.onVisibilityPlay)
                    : ((this.state = "playing"),
                      document.addEventListener("visibilitychange", this.onVisibilityChange),
                      this.tick());
            }),
                (e.prototype.tick = function () {
                    if ("playing" !== this.state) return;
                    let t = "number" == typeof this.autoPlay ? this.autoPlay : 3e3;
                    this.clear(),
                        (this.timeout = setTimeout(() => {
                            this.onTick(), this.tick();
                        }, t));
                }),
                (e.prototype.stop = function () {
                    (this.state = "stopped"),
                        this.clear(),
                        document.removeEventListener("visibilitychange", this.onVisibilityChange);
                }),
                (e.prototype.clear = function () {
                    clearTimeout(this.timeout);
                }),
                (e.prototype.pause = function () {
                    "playing" === this.state && ((this.state = "paused"), this.clear());
                }),
                (e.prototype.unpause = function () {
                    "paused" === this.state && this.play();
                }),
                (e.prototype.visibilityChange = function () {
                    this[document.hidden ? "pause" : "unpause"]();
                }),
                (e.prototype.visibilityPlay = function () {
                    this.play(), document.removeEventListener("visibilitychange", this.onVisibilityPlay);
                }),
                Object.assign(t.defaults, { pauseAutoPlayOnHover: !0 }),
                (t.create.player = function () {
                    (this.player = new e(this.options.autoPlay, () => {
                        this.next(!0);
                    })),
                        this.on("activate", this.activatePlayer),
                        this.on("uiChange", this.stopPlayer),
                        this.on("pointerDown", this.stopPlayer),
                        this.on("deactivate", this.deactivatePlayer);
                });
            let i = t.prototype;
            return (
                (i.activatePlayer = function () {
                    this.options.autoPlay && (this.player.play(), this.element.addEventListener("mouseenter", this));
                }),
                (i.playPlayer = function () {
                    this.player.play();
                }),
                (i.stopPlayer = function () {
                    this.player.stop();
                }),
                (i.pausePlayer = function () {
                    this.player.pause();
                }),
                (i.unpausePlayer = function () {
                    this.player.unpause();
                }),
                (i.deactivatePlayer = function () {
                    this.player.stop(), this.element.removeEventListener("mouseenter", this);
                }),
                (i.onmouseenter = function () {
                    this.options.pauseAutoPlayOnHover &&
                        (this.player.pause(), this.element.addEventListener("mouseleave", this));
                }),
                (i.onmouseleave = function () {
                    this.player.unpause(), this.element.removeEventListener("mouseleave", this);
                }),
                (t.Player = e),
                t
            );
        });
    })({ exports: {} });
    !(function (t) {
        !(function (e, i) {
            t.exports ? (t.exports = i(s.exports, r.exports)) : i(e.Flickity, e.fizzyUIUtils);
        })("undefined" != typeof window ? window : e, function (t, e) {
            let i = t.prototype;
            return (
                (i.insert = function (t, e) {
                    let i = this._makeCells(t);
                    if (!i || !i.length) return;
                    let s = this.cells.length;
                    e = void 0 === e ? s : e;
                    let n = (function (t) {
                            let e = document.createDocumentFragment();
                            return t.forEach((t) => e.appendChild(t.element)), e;
                        })(i),
                        o = e === s;
                    if (o) this.slider.appendChild(n);
                    else {
                        let t = this.cells[e].element;
                        this.slider.insertBefore(n, t);
                    }
                    if (0 === e) this.cells = i.concat(this.cells);
                    else if (o) this.cells = this.cells.concat(i);
                    else {
                        let t = this.cells.splice(e, s - e);
                        this.cells = this.cells.concat(i).concat(t);
                    }
                    this._sizeCells(i), this.cellChange(e), this.positionSliderAtSelected();
                }),
                (i.append = function (t) {
                    this.insert(t, this.cells.length);
                }),
                (i.prepend = function (t) {
                    this.insert(t, 0);
                }),
                (i.remove = function (t) {
                    let i = this.getCells(t);
                    if (!i || !i.length) return;
                    let s = this.cells.length - 1;
                    i.forEach((t) => {
                        t.remove();
                        let i = this.cells.indexOf(t);
                        (s = Math.min(i, s)), e.removeFrom(this.cells, t);
                    }),
                        this.cellChange(s),
                        this.positionSliderAtSelected();
                }),
                (i.cellSizeChange = function (t) {
                    let e = this.getCell(t);
                    if (!e) return;
                    e.getSize();
                    let i = this.cells.indexOf(e);
                    this.cellChange(i);
                }),
                (i.cellChange = function (t) {
                    let e = this.selectedElement;
                    this._positionCells(t), this._updateWrapShiftCells(), this.setGallerySize();
                    let i = this.getCell(e);
                    i && (this.selectedIndex = this.getCellSlideIndex(i)),
                        (this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex)),
                        this.emitEvent("cellChange", [t]),
                        this.select(this.selectedIndex);
                }),
                t
            );
        });
    })({ exports: {} });
    !(function (t) {
        !(function (e, i) {
            t.exports ? (t.exports = i(s.exports, r.exports)) : i(e.Flickity, e.fizzyUIUtils);
        })("undefined" != typeof window ? window : e, function (t, e) {
            const i = "data-flickity-lazyload",
                s = `${i}-src`,
                n = `${i}-srcset`,
                o = `img[${i}], img[${s}], img[${n}], source[${n}]`;
            t.create.lazyLoad = function () {
                this.on("select", this.lazyLoad), (this.handleLazyLoadComplete = this.onLazyLoadComplete.bind(this));
            };
            let r = t.prototype;
            function l(t) {
                if (t.matches("img")) {
                    let e = t.getAttribute(i),
                        o = t.getAttribute(s),
                        r = t.getAttribute(n);
                    if (e || o || r) return t;
                }
                return [...t.querySelectorAll(o)];
            }
            function a(t, e) {
                (this.img = t), (this.onComplete = e), this.load();
            }
            return (
                (r.lazyLoad = function () {
                    let { lazyLoad: t } = this.options;
                    if (!t) return;
                    let e = "number" == typeof t ? t : 0;
                    this.getAdjacentCellElements(e)
                        .map(l)
                        .flat()
                        .forEach((t) => new a(t, this.handleLazyLoadComplete));
                }),
                (r.onLazyLoadComplete = function (t, e) {
                    let i = this.getParentCell(t),
                        s = i && i.element;
                    this.cellSizeChange(s), this.dispatchEvent("lazyLoad", e, s);
                }),
                (a.prototype.handleEvent = e.handleEvent),
                (a.prototype.load = function () {
                    this.img.addEventListener("load", this), this.img.addEventListener("error", this);
                    let t = this.img.getAttribute(i) || this.img.getAttribute(s),
                        e = this.img.getAttribute(n);
                    (this.img.src = t),
                        e && this.img.setAttribute("srcset", e),
                        this.img.removeAttribute(i),
                        this.img.removeAttribute(s),
                        this.img.removeAttribute(n);
                }),
                (a.prototype.onload = function (t) {
                    this.complete(t, "flickity-lazyloaded");
                }),
                (a.prototype.onerror = function (t) {
                    this.complete(t, "flickity-lazyerror");
                }),
                (a.prototype.complete = function (t, e) {
                    this.img.removeEventListener("load", this),
                        this.img.removeEventListener("error", this),
                        (this.img.parentNode.matches("picture") ? this.img.parentNode : this.img).classList.add(e),
                        this.onComplete(this.img, t);
                }),
                (t.LazyLoader = a),
                t
            );
        });
    })({ exports: {} });
    var d = { exports: {} };
    /*!
     * imagesLoaded v5.0.0
     * JavaScript is all like "You images are done yet or what?"
     * MIT License
     */
    !(function (t) {
        !(function (e, i) {
            t.exports ? (t.exports = i(e, n.exports)) : (e.imagesLoaded = i(e, e.EvEmitter));
        })("undefined" != typeof window ? window : e, function (t, e) {
            let i = t.jQuery,
                s = t.console;
            function n(t, e, o) {
                if (!(this instanceof n)) return new n(t, e, o);
                let r = t;
                var l;
                ("string" == typeof t && (r = document.querySelectorAll(t)), r)
                    ? ((this.elements =
                          ((l = r),
                          Array.isArray(l) ? l : "object" == typeof l && "number" == typeof l.length ? [...l] : [l])),
                      (this.options = {}),
                      "function" == typeof e ? (o = e) : Object.assign(this.options, e),
                      o && this.on("always", o),
                      this.getImages(),
                      i && (this.jqDeferred = new i.Deferred()),
                      setTimeout(this.check.bind(this)))
                    : s.error(`Bad element for imagesLoaded ${r || t}`);
            }
            (n.prototype = Object.create(e.prototype)),
                (n.prototype.getImages = function () {
                    (this.images = []), this.elements.forEach(this.addElementImages, this);
                });
            const o = [1, 9, 11];
            n.prototype.addElementImages = function (t) {
                "IMG" === t.nodeName && this.addImage(t),
                    !0 === this.options.background && this.addElementBackgroundImages(t);
                let { nodeType: e } = t;
                if (!e || !o.includes(e)) return;
                let i = t.querySelectorAll("img");
                for (let t of i) this.addImage(t);
                if ("string" == typeof this.options.background) {
                    let e = t.querySelectorAll(this.options.background);
                    for (let t of e) this.addElementBackgroundImages(t);
                }
            };
            const r = /url\((['"])?(.*?)\1\)/gi;
            function l(t) {
                this.img = t;
            }
            function a(t, e) {
                (this.url = t), (this.element = e), (this.img = new Image());
            }
            return (
                (n.prototype.addElementBackgroundImages = function (t) {
                    let e = getComputedStyle(t);
                    if (!e) return;
                    let i = r.exec(e.backgroundImage);
                    for (; null !== i; ) {
                        let s = i && i[2];
                        s && this.addBackground(s, t), (i = r.exec(e.backgroundImage));
                    }
                }),
                (n.prototype.addImage = function (t) {
                    let e = new l(t);
                    this.images.push(e);
                }),
                (n.prototype.addBackground = function (t, e) {
                    let i = new a(t, e);
                    this.images.push(i);
                }),
                (n.prototype.check = function () {
                    if (((this.progressedCount = 0), (this.hasAnyBroken = !1), !this.images.length))
                        return void this.complete();
                    let t = (t, e, i) => {
                        setTimeout(() => {
                            this.progress(t, e, i);
                        });
                    };
                    this.images.forEach(function (e) {
                        e.once("progress", t), e.check();
                    });
                }),
                (n.prototype.progress = function (t, e, i) {
                    this.progressedCount++,
                        (this.hasAnyBroken = this.hasAnyBroken || !t.isLoaded),
                        this.emitEvent("progress", [this, t, e]),
                        this.jqDeferred && this.jqDeferred.notify && this.jqDeferred.notify(this, t),
                        this.progressedCount === this.images.length && this.complete(),
                        this.options.debug && s && s.log(`progress: ${i}`, t, e);
                }),
                (n.prototype.complete = function () {
                    let t = this.hasAnyBroken ? "fail" : "done";
                    if (
                        ((this.isComplete = !0),
                        this.emitEvent(t, [this]),
                        this.emitEvent("always", [this]),
                        this.jqDeferred)
                    ) {
                        let t = this.hasAnyBroken ? "reject" : "resolve";
                        this.jqDeferred[t](this);
                    }
                }),
                (l.prototype = Object.create(e.prototype)),
                (l.prototype.check = function () {
                    this.getIsImageComplete()
                        ? this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
                        : ((this.proxyImage = new Image()),
                          this.img.crossOrigin && (this.proxyImage.crossOrigin = this.img.crossOrigin),
                          this.proxyImage.addEventListener("load", this),
                          this.proxyImage.addEventListener("error", this),
                          this.img.addEventListener("load", this),
                          this.img.addEventListener("error", this),
                          (this.proxyImage.src = this.img.currentSrc || this.img.src));
                }),
                (l.prototype.getIsImageComplete = function () {
                    return this.img.complete && this.img.naturalWidth;
                }),
                (l.prototype.confirm = function (t, e) {
                    this.isLoaded = t;
                    let { parentNode: i } = this.img,
                        s = "PICTURE" === i.nodeName ? i : this.img;
                    this.emitEvent("progress", [this, s, e]);
                }),
                (l.prototype.handleEvent = function (t) {
                    let e = "on" + t.type;
                    this[e] && this[e](t);
                }),
                (l.prototype.onload = function () {
                    this.confirm(!0, "onload"), this.unbindEvents();
                }),
                (l.prototype.onerror = function () {
                    this.confirm(!1, "onerror"), this.unbindEvents();
                }),
                (l.prototype.unbindEvents = function () {
                    this.proxyImage.removeEventListener("load", this),
                        this.proxyImage.removeEventListener("error", this),
                        this.img.removeEventListener("load", this),
                        this.img.removeEventListener("error", this);
                }),
                (a.prototype = Object.create(l.prototype)),
                (a.prototype.check = function () {
                    this.img.addEventListener("load", this),
                        this.img.addEventListener("error", this),
                        (this.img.src = this.url),
                        this.getIsImageComplete() &&
                            (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"), this.unbindEvents());
                }),
                (a.prototype.unbindEvents = function () {
                    this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
                }),
                (a.prototype.confirm = function (t, e) {
                    (this.isLoaded = t), this.emitEvent("progress", [this, this.element, e]);
                }),
                (n.makeJQueryPlugin = function (e) {
                    (e = e || t.jQuery) &&
                        ((i = e),
                        (i.fn.imagesLoaded = function (t, e) {
                            return new n(this, t, e).jqDeferred.promise(i(this));
                        }));
                }),
                n.makeJQueryPlugin(),
                n
            );
        });
    })(d),
        (function (t) {
            !(function (e, i) {
                t.exports ? (t.exports = i(s.exports, d.exports)) : i(e.Flickity, e.imagesLoaded);
            })("undefined" != typeof window ? window : e, function (t, e) {
                return (
                    (t.create.imagesLoaded = function () {
                        this.on("activate", this.imagesLoaded);
                    }),
                    (t.prototype.imagesLoaded = function () {
                        if (!this.options.imagesLoaded) return;
                        e(this.slider).on("progress", (t, e) => {
                            let i = this.getParentCell(e.img);
                            this.cellSizeChange(i && i.element),
                                this.options.freeScroll || this.positionSliderAtSelected();
                        });
                    }),
                    t
                );
            });
        })({ exports: {} }),
        /*!
         * Flickity v3.0.0
         * Touch, responsive, flickable carousels
         *
         * Licensed GPLv3 for open source use
         * or Flickity Commercial License for commercial use
         *
         * https://flickity.metafizzy.co
         * Copyright 2015-2022 Metafizzy
         */
        (function (t) {
            if (t.exports) {
                const e = s.exports;
                t.exports = e;
            }
        })(i);
    var u = i.exports;
    /*!
     * Flickity asNavFor v3.0.0
     * enable asNavFor for Flickity
     */
    !(function (t) {
        !(function (e, s) {
            t.exports ? (t.exports = s(i.exports, r.exports)) : (e.Flickity = s(e.Flickity, e.fizzyUIUtils));
        })(window, function (t, e) {
            t.create.asNavFor = function () {
                this.on("activate", this.activateAsNavFor),
                    this.on("deactivate", this.deactivateAsNavFor),
                    this.on("destroy", this.destroyAsNavFor);
                let t = this.options.asNavFor;
                t &&
                    setTimeout(() => {
                        this.setNavCompanion(t);
                    });
            };
            let i = t.prototype;
            return (
                (i.setNavCompanion = function (i) {
                    i = e.getQueryElement(i);
                    let s = t.data(i);
                    s &&
                        s !== this &&
                        ((this.navCompanion = s),
                        (this.onNavCompanionSelect = () => {
                            this.navCompanionSelect();
                        }),
                        s.on("select", this.onNavCompanionSelect),
                        this.on("staticClick", this.onNavStaticClick),
                        this.navCompanionSelect(!0));
                }),
                (i.navCompanionSelect = function (t) {
                    let e = this.navCompanion && this.navCompanion.selectedCells;
                    if (!e) return;
                    let i = e[0],
                        s = this.navCompanion.cells.indexOf(i),
                        n = s + e.length - 1,
                        o = Math.floor(((r = s), (l = n), (a = this.navCompanion.cellAlign), (l - r) * a + r));
                    var r, l, a;
                    if ((this.selectCell(o, !1, t), this.removeNavSelectedElements(), o >= this.cells.length)) return;
                    let h = this.cells.slice(s, n + 1);
                    (this.navSelectedElements = h.map((t) => t.element)), this.changeNavSelectedClass("add");
                }),
                (i.changeNavSelectedClass = function (t) {
                    this.navSelectedElements.forEach(function (e) {
                        e.classList[t]("is-nav-selected");
                    });
                }),
                (i.activateAsNavFor = function () {
                    this.navCompanionSelect(!0);
                }),
                (i.removeNavSelectedElements = function () {
                    this.navSelectedElements &&
                        (this.changeNavSelectedClass("remove"), delete this.navSelectedElements);
                }),
                (i.onNavStaticClick = function (t, e, i, s) {
                    "number" == typeof s && this.navCompanion.selectCell(s);
                }),
                (i.deactivateAsNavFor = function () {
                    this.removeNavSelectedElements();
                }),
                (i.destroyAsNavFor = function () {
                    this.navCompanion &&
                        (this.navCompanion.off("select", this.onNavCompanionSelect),
                        this.off("staticClick", this.onNavStaticClick),
                        delete this.navCompanion);
                }),
                t
            );
        });
    })({ exports: {} });
    const p = "[data-custom-scrollbar-items]",
        f = "[data-custom-scrollbar]",
        m = "[data-custom-scrollbar-track]";
    class g {
        constructor(t) {
            (this.itemsParent = t.querySelector(p)),
                (this.scrollbar = t.querySelector(f)),
                (this.scrollbarTrack = t.querySelector(m)),
                (this.trackWidth = 0),
                (this.calcPositionEvent = window.theme.throttle(() => this.calculatePosition(), 50)),
                (this.calcTrackEvent = () => this.calculateTrackWidth()),
                this.scrollbar && this.itemsParent && (this.events(), this.calculateTrackWidth());
        }
        events() {
            this.itemsParent.addEventListener("scroll", this.calcPositionEvent),
                document.addEventListener("theme:resize:width", this.calcTrackEvent);
        }
        calculateTrackWidth() {
            (this.trackWidth = 100 / this.itemsParent.children.length),
                (this.trackWidth = this.trackWidth < 5 ? 5 : this.trackWidth),
                this.scrollbar.style.setProperty("--track-width", `${this.trackWidth}%`);
        }
        calculatePosition() {
            const t = this.scrollbar.clientWidth * ((100 - this.trackWidth) / 100);
            let e = this.itemsParent.scrollLeft / (this.itemsParent.scrollWidth - this.itemsParent.clientWidth);
            (e *= t), this.scrollbar.style.setProperty("--position", `${Math.round(e)}px`);
        }
        destroy() {
            this.itemsParent.removeEventListener("scroll", this.calcPositionEvent),
                document.removeEventListener("theme:resize:width", this.calcTrackEvent);
        }
    }
    const v = {
            productSlideshow: "[data-product-slideshow]",
            productImage: "[data-product-single-media-wrapper]",
            productThumbs: "[data-product-single-media-thumbs]",
            productThumbsVertical: "[data-product-single-media-thumbs-vertical]",
            productThumb: "[data-thumbnail]",
            productThumbLink: "[data-thumbnail-id]",
            deferredMediaButton: "[data-deferred-media-button]",
            mediaType: "data-type",
            id: "data-id",
            tabIndex: "tabindex",
            arrows: "data-arrows",
            dots: "data-dots",
            navSelected: ".is-nav-selected",
            scrollable: "[data-custom-scrollbar-items]",
        },
        y = "flickity-enabled",
        b = "media--hidden",
        w = "is-focused",
        E = "product__images__slider-nav--arrows",
        S = "is-moving",
        C = "is-nav-selected",
        x = "data-thumbnail";
    class k {
        constructor(t) {
            (this.container = t.container),
                (this.scrollable = this.container.querySelector(v.scrollable)),
                (this.slideshow = this.container.querySelector(v.productSlideshow)),
                (this.productImages = this.container.querySelectorAll(v.productImage)),
                (this.thumbs = this.container.querySelector(v.productThumbs)),
                (this.thumbsVertical = this.container.querySelector(v.productThumbsVertical)),
                (this.flkty = null),
                (this.flktyNav = null),
                (this.flickityOptionsNav = null),
                (this.resizeEvent = () => this.resizeEvents()),
                (this.selectMediaEvent = (t) => this.showMediaOnVariantSelect(t)),
                (this.thumbNavKeydown = (t) => this.onThumbNavKeydown(t)),
                this.slideshow &&
                    (this.flickityOptionsNav = {
                        asNavFor: this.slideshow,
                        pageDots: !1,
                        prevNextButtons: !0,
                        arrowShape: theme.icons.arrowNavSlider,
                        groupCells: !0,
                        contain: !0,
                    }),
                this.productImages.length > 1 && this.init();
        }
        init() {
            this.createSlider(),
                this.createSliderNav(),
                this.createScrollable(),
                this.container.addEventListener("theme:media:select", this.selectMediaEvent),
                document.addEventListener("theme:resize:width", this.resizeEvent);
        }
        resizeEvents() {
            this.initSliderNavVertical(), this.checkThumbsWidth(), this.createScrollable();
        }
        createSlider() {
            if (!this.slideshow) return;
            const t = this,
                e = this.slideshow.querySelectorAll(`[${v.mediaType}]`)[0],
                i = "true" === this.slideshow.getAttribute(v.arrows),
                s = "true" === this.slideshow.getAttribute(v.dots),
                n = {
                    autoPlay: !1,
                    arrowShape: theme.icons.arrowNavSlider,
                    prevNextButtons: i,
                    contain: !0,
                    pageDots: s,
                    adaptiveHeight: !0,
                    wrapAround: !0,
                };
            if (((this.flkty = new u(this.slideshow, n)), e)) {
                const t = e.getAttribute(v.mediaType);
                ("model" !== t && "video" !== t && "external_video" !== t) ||
                    ((this.flkty.options.draggable = !1), this.flkty.updateDraggable());
            }
            this.flkty.on("dragStart", function () {
                t.slideshow.classList.add(S);
            }),
                this.flkty.on("change", function (e) {
                    const i = this.cells[e].element,
                        s = this.selectedElement,
                        n = theme.isMobile();
                    if (
                        (i.dispatchEvent(new CustomEvent("theme:media:hidden")),
                        s.classList.remove(b),
                        t.thumbsVertical && !n)
                    ) {
                        const i = t.thumbsVertical.querySelector(v.navSelected),
                            s = t.thumbsVertical.querySelector(`[${x}="${e}"]`);
                        i && i.classList.remove(C), s && s.classList.add(C), t.scrollToThumb();
                    }
                }),
                this.flkty.on("settle", function () {
                    const e = this.selectedElement,
                        i = e.getAttribute(v.mediaType);
                    "model" === i || "video" === i || "external_video" === i
                        ? ((t.flkty.options.draggable = !1), t.flkty.updateDraggable())
                        : ((t.flkty.options.draggable = !0), t.flkty.updateDraggable()),
                        t.switchMedia(e),
                        t.slideshow.classList.remove(S);
                });
        }
        // createSliderNav() {
        //     const t = this.thumbs || this.thumbsVertical;
        //     t &&
        //         this.slideshow &&
        //         (this.thumbsVertical
        //             ? this.initSliderNavVertical()
        //             : (this.flktyNav = new u(t, this.flickityOptionsNav)),
        //         this.checkThumbsWidth(),
        //         t.addEventListener("keydown", this.thumbNavKeydown),
        //         t.querySelectorAll(v.productThumbLink).forEach((t, e) => {
        //             const i = t.closest(v.productThumb);
        //             this.thumbsVertical && i && 0 === e && i.classList.add(C),
        //                 t.addEventListener("click", (e) => {
        //                     e.preventDefault();
        //                     const i = t.closest(v.productThumb);
        //                     this.selectMainSlideForThumb(i);
        //                 });
        //         }));
        // }
        createSliderNav() {
            const t = this.thumbs || this.thumbsVertical;

            if (!t || !this.slideshow) return;

            // Do NOT initialize Flickity for thumbnails
            this.flktyNav = null;

            this.checkThumbsWidth();

            t.addEventListener("keydown", this.thumbNavKeydown);

            t.querySelectorAll(v.productThumbLink).forEach((t, e) => {
                const i = t.closest(v.productThumb);

                this.thumbsVertical &&
                    i &&
                    0 === e &&
                    i.classList.add(C);

                t.addEventListener("click", (e) => {
                    e.preventDefault();

                    const i = t.closest(v.productThumb);

                    this.selectMainSlideForThumb(i);
                });
            });
        }
        selectMainSlideForThumb(t) {
            if (!t || null === this.flkty) return;
            const e = parseInt(t.getAttribute(x), 10);
            Number.isNaN(e) || this.flkty.selectCell(e);
        }
        onThumbNavKeydown(t) {
            if (" " !== t.key) return;
            const e = t.target.closest?.(v.productThumb),
                i = this.thumbs || this.thumbsVertical;
            if (!e || !i || !i.contains(e)) return;
            const s = t.target.tagName;
            "INPUT" === s ||
                "TEXTAREA" === s ||
                "SELECT" === s ||
                t.target.isContentEditable ||
                (t.preventDefault(), this.selectMainSlideForThumb(e));
        }
        initSliderNavVertical() {
            if (!this.thumbsVertical || !this.slideshow) return;
            const t = theme.isMobile();
            t && !this.flktyNav
                ? (this.flktyNav = new u(this.thumbsVertical, this.flickityOptionsNav))
                : !t && this.flktyNav && (this.flktyNav.destroy(), (this.flktyNav = null));
        }
        scrollToThumb() {
            const t = this.thumbsVertical;
            if (t) {
                const e = t.querySelector(v.navSelected);
                if (!e) return;
                const i = t.scrollTop,
                    s = t.scrollLeft,
                    n = t.offsetWidth,
                    o = t.offsetHeight,
                    r = i + o,
                    l = s + n,
                    a = e.offsetTop,
                    h = e.offsetLeft,
                    c = e.offsetWidth,
                    d = e.offsetHeight,
                    u = i > a,
                    p = s > h,
                    f = h + c > l,
                    m = a + d > r || u,
                    g = f || p,
                    y = theme.isMobile();
                if (m || g) {
                    let e = a - o + d,
                        i = h - n + c;
                    u && (e = a),
                        f && y && (i += parseInt(window.getComputedStyle(t).paddingRight)),
                        p && ((i = h), y && (i -= parseInt(window.getComputedStyle(t).paddingLeft))),
                        t.scrollTo({ top: e, left: i, behavior: "smooth" });
                }
            }
        }
        checkThumbsWidth() {
            if (this.thumbs || (this.thumbsVertical && theme.isMobile())) {
                const t = this.thumbs || this.thumbsVertical,
                    e = t.querySelectorAll(v.productThumb),
                    i = 2 * parseInt(window.getComputedStyle(t).paddingLeft.replace("px", "")),
                    s = t.offsetWidth - i;
                let n = 0;
                e.forEach((t) => {
                    n += t.offsetWidth;
                }),
                    s < n ? t.classList.add(E) : t.classList.remove(E),
                    null !== this.flktyNav && "object" == typeof this.flktyNav && this.flktyNav.resize();
            }
        }
        createScrollable() {
            this.scrollable &&
                (theme.isMobile()
                    ? (this.customScrollbar = new g(this.container))
                    : this.customScrollbar && this.customScrollbar.destroy());
        }
        switchMedia(t) {
            const e = Array.prototype.filter.call(t.parentNode.children, function (e) {
                return e !== t;
            });
            document.body.classList.contains(w) && t.dispatchEvent(new Event("focus")),
                e.length &&
                    e.forEach((t) => {
                        t.classList.add(b), t.dispatchEvent(new CustomEvent("theme:media:hidden"));
                    }),
                t.classList.remove(b),
                t.dispatchEvent(new CustomEvent("theme:media:visible"));
            const i = t.querySelector("deferred-media");
            i &&
                !0 !== i.getAttribute("loaded") &&
                t.querySelector(v.deferredMediaButton).dispatchEvent(new Event("click", { bubbles: !1 }));
        }
        // showMediaOnVariantSelect(t) {
        //     const e = t.detail.id,
        //         i = this.container.querySelector(`[data-media-id="${e}"]`);
        //     if (i) {
        //         const t = this.container.querySelector(v.productSlideshow);
        //         if (t && t.classList.contains(y)) {
        //             const t = Array.from(i.parentElement.children).indexOf(i);
        //             this.flkty?.select(t);
        //         }
        //         if (this.scrollable)
        //             if (window.innerWidth >= theme.sizes.small) {
        //                 const t = 60;
        //                 window.scrollTo({
        //                     top: i.getBoundingClientRect().top + window.scrollY - t,
        //                     left: 0,
        //                     behavior: "smooth",
        //                 });
        //             } else {
        //                 const t = this.container.querySelector(v.productImagesScroller);
        //                 if (!t) return;
        //                 t.scrollTo({ top: 0, left: i.getBoundingClientRect().left + t.scrollLeft, behavior: "smooth" });
        //             }
        //     }
        // }
        showMediaOnVariantSelect(t) {
            const e = t.detail.id,
                i = this.container.querySelector(`[data-media-id="${e}"]`);

            // Hide all color thumbnails
            this.container.querySelectorAll('[thumbnail-color]').forEach((el) => {
                el.style.display = 'none';
            });

            if (i) {
                // Get selected media alt (color)
                const selectedColor = i.querySelector('img')?.alt?.trim();

                // Show thumbnails matching selected color
                if (selectedColor) {
                    this.container
                        .querySelectorAll('[thumbnail-color]')
                        .forEach((el) => {
                            if (el.getAttribute('thumbnail-color')?.trim() === selectedColor) {
                                el.style.display = '';
                            }
                        });
                }

                const t = this.container.querySelector(v.productSlideshow);

                if (t && t.classList.contains(y)) {
                    const t = Array.from(i.parentElement.children).indexOf(i);
                    this.flkty?.select(t);
                }

                if (this.scrollable)
                    if (window.innerWidth >= theme.sizes.small) {
                        const t = 60;
                        window.scrollTo({
                            top: i.getBoundingClientRect().top + window.scrollY - t,
                            left: 0,
                            behavior: "smooth",
                        });
                    } else {
                        const t = this.container.querySelector(v.productImagesScroller);
                        if (!t) return;
                        t.scrollTo({
                            top: 0,
                            left: i.getBoundingClientRect().left + t.scrollLeft,
                            behavior: "smooth",
                        });
                    }
            }
        }
        unload() {
            document.removeEventListener("theme:resize:width", this.resizeEvent);
            const t = this.thumbs || this.thumbsVertical;
            t && t.removeEventListener("keydown", this.thumbNavKeydown);
        }
    }
    const L = {};
    function D(t = {}) {
        if ((t.type || (t.type = "json"), t.url))
            return L[t.url]
                ? L[t.url]
                : (function (t, e) {
                      const i = new Promise((i, s) => {
                          "text" === e
                              ? fetch(t)
                                    .then((t) => t.text())
                                    .then((t) => {
                                        i(t);
                                    })
                                    .catch((t) => {
                                        s(t);
                                    })
                              : (function (t, e, i) {
                                    let s = document.getElementsByTagName("head")[0],
                                        n = !1,
                                        o = document.createElement("script");
                                    (o.src = t),
                                        (o.onload = o.onreadystatechange =
                                            function () {
                                                n ||
                                                (this.readyState &&
                                                    "loaded" != this.readyState &&
                                                    "complete" != this.readyState)
                                                    ? i()
                                                    : ((n = !0), e());
                                            }),
                                        s.appendChild(o);
                                })(
                                    t,
                                    function () {
                                        i();
                                    },
                                    function () {
                                        s();
                                    }
                                );
                      });
                      return (L[t] = i), i;
                  })(t.url, t.type);
        if (t.json)
            return L[t.json]
                ? Promise.resolve(L[t.json])
                : window
                      .fetch(t.json)
                      .then((t) => t.json())
                      .then((e) => ((L[t.json] = e), e));
        if (t.name) {
            const e = "".concat(t.name, t.version);
            return L[e]
                ? L[e]
                : (function (t) {
                      const e = "".concat(t.name, t.version),
                          i = new Promise((e, i) => {
                              try {
                                  window.Shopify.loadFeatures([
                                      {
                                          name: t.name,
                                          version: t.version,
                                          onLoad: (t) => {
                                              !(function (t, e, i) {
                                                  i ? e(i) : t();
                                              })(e, i, t);
                                          },
                                      },
                                  ]);
                              } catch (t) {
                                  i(t);
                              }
                          });
                      return (L[e] = i), i;
                  })(t);
        }
        return Promise.reject();
    }
    function A(t, e) {
        e = e || {};
        var i = t.tabIndex;
        (t.tabIndex = -1),
            (t.dataset.tabIndex = i),
            t.focus(),
            void 0 !== e.className && t.classList.add(e.className),
            t.addEventListener("blur", function s(n) {
                n.target.removeEventListener(n.type, s),
                    (t.tabIndex = i),
                    delete t.dataset.tabIndex,
                    void 0 !== e.className && t.classList.remove(e.className);
            });
    }
    function P(t) {
        return Array.prototype.slice
            .call(
                t.querySelectorAll(
                    "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled"
                )
            )
            .filter(function (t) {
                return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
            });
    }
    var T = {};
    function I() {
        document.removeEventListener("focusin", T.focusin),
            document.removeEventListener("focusout", T.focusout),
            document.removeEventListener("keydown", T.keydown);
    }
    var z = Object.freeze({
        __proto__: null,
        forceFocus: A,
        focusHash: function (t) {
            t = t || {};
            var e = window.location.hash,
                i = document.getElementById(e.slice(1));
            if (i && t.ignore && i.matches(t.ignore)) return !1;
            e && i && A(i, t);
        },
        bindInPageLinks: function (t) {
            return (
                (t = t || {}),
                Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter(function (e) {
                    if ("#" === e.hash || "" === e.hash) return !1;
                    if (t.ignore && e.matches(t.ignore)) return !1;
                    if (((i = e.hash.substr(1)), null === document.getElementById(i))) return !1;
                    var i,
                        s = document.querySelector(e.hash);
                    return (
                        !!s &&
                        (e.addEventListener("click", function () {
                            A(s, t);
                        }),
                        !0)
                    );
                })
            );
        },
        focusable: P,
        trapFocus: function (t, e) {
            e = e || {};
            var i = P(t),
                s = e.elementToFocus || t,
                n = i[0],
                o = i[i.length - 1];
            I(),
                (T.focusin = function (e) {
                    t === e.target || t.contains(e.target) || n.focus(),
                        (e.target !== t && e.target !== o && e.target !== n) ||
                            document.addEventListener("keydown", T.keydown);
                }),
                (T.focusout = function () {
                    document.removeEventListener("keydown", T.keydown);
                }),
                (T.keydown = function (e) {
                    "Tab" === e.code &&
                        (e.target !== o || e.shiftKey || (e.preventDefault(), n.focus()),
                        (e.target !== t && e.target !== n) || !e.shiftKey || (e.preventDefault(), o.focus()));
                }),
                document.addEventListener("focusout", T.focusout),
                document.addEventListener("focusin", T.focusin),
                A(s, e);
        },
        removeTrapFocus: I,
        accessibleLinks: function (t, e) {
            if ("string" != typeof t) throw new TypeError(t + " is not a String.");
            if (0 !== (t = document.querySelectorAll(t)).length) {
                (e = e || {}).messages = e.messages || {};
                var i = {
                        newWindow: e.messages.newWindow || "Opens in a new window.",
                        external: e.messages.external || "Opens external website.",
                        newWindowExternal: e.messages.newWindowExternal || "Opens external website in a new window.",
                    },
                    s = e.prefix || "a11y",
                    n = {
                        newWindow: s + "-new-window-message",
                        external: s + "-external-message",
                        newWindowExternal: s + "-new-window-external-message",
                    };
                t.forEach(function (t) {
                    var e = t.getAttribute("target"),
                        i = t.getAttribute("rel"),
                        s = (function (t) {
                            return t.hostname !== window.location.hostname;
                        })(t),
                        o = "_blank" === e,
                        r = null === i || -1 === i.indexOf("noopener");
                    if (o && r) {
                        var l = null === i ? "noopener" : i + " noopener";
                        t.setAttribute("rel", l);
                    }
                    s && o
                        ? t.setAttribute("aria-describedby", n.newWindowExternal)
                        : s
                          ? t.setAttribute("aria-describedby", n.external)
                          : o && t.setAttribute("aria-describedby", n.newWindow);
                }),
                    (function (t) {
                        var e = document.createElement("ul"),
                            i = Object.keys(t).reduce(function (e, i) {
                                return e + "<li id=" + n[i] + ">" + t[i] + "</li>";
                            }, "");
                        e.setAttribute("hidden", !0), (e.innerHTML = i), document.body.appendChild(e);
                    })(i);
            }
        },
    });
    const W = ".pswp",
        N = ".pswp__custom-close",
        M = "iframe, video",
        _ = ".pswp__thumbs",
        F = "data-pswp-option-classes",
        B = "is-current",
        V = "pswp--custom-loader",
        q = "pswp--custom-opening",
        O = "pswp__loader",
        $ = `<div class="${O}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`;
    class j {
        constructor(t, e = "") {
            (this.a11y = z),
                (this.items = t),
                (this.pswpElement = document.querySelectorAll(W)[0]),
                (this.popup = null),
                (this.popupThumbs = null),
                (this.popupThumbsContainer = this.pswpElement.querySelector(_)),
                (this.closeBtn = this.pswpElement.querySelector(N)),
                (this.closeButtonClick = () => this.closeButtonClickEvent());
            (this.options = "" !== e ? e : { history: !1, focus: !1, mainClass: "" }), this.init();
        }
        init() {
            this.pswpElement.classList.add(q),
                this.initLoader(),
                D({ url: window.theme.assets.photoswipe })
                    .then(() => this.loadPopup())
                    .catch((t) => console.error(t));
        }
        initLoader() {
            if (this.pswpElement.classList.contains(V) && "" !== this.options && this.options.mainClass) {
                this.pswpElement.setAttribute(F, this.options.mainClass);
                let t = document.createElement("div");
                (t.innerHTML = $), (t = t.firstChild), this.pswpElement.appendChild(t);
            } else this.pswpElement.setAttribute(F, "");
        }
        loadPopup() {
            const t = window.themePhotoswipe.PhotoSwipe.default,
                e = window.themePhotoswipe.PhotoSwipeUI.default;
            this.pswpElement.classList.contains(V) && this.pswpElement.classList.remove(V),
                this.pswpElement.classList.remove(q),
                (this.popup = new t(this.pswpElement, e, this.items, this.options)),
                this.popup.init(),
                this.a11y.trapFocus(this.pswpElement),
                this.thumbsActions(),
                this.closeBtn && this.closeBtn.addEventListener("click", this.closeButtonClick),
                this.popup.listen("close", () => this.onClose());
        }
        closeButtonClickEvent() {
            this.popup.close(), this.a11y.removeTrapFocus(), null !== theme.a11yTrigger && theme.a11yTrigger.focus();
        }
        thumbsActions() {
            this.popupThumbsContainer &&
                this.popupThumbsContainer.firstChild &&
                (this.popupThumbsContainer.addEventListener("wheel", (t) => this.stopDisabledScroll(t)),
                this.popupThumbsContainer.addEventListener("mousewheel", (t) => this.stopDisabledScroll(t)),
                this.popupThumbsContainer.addEventListener("DOMMouseScroll", (t) => this.stopDisabledScroll(t)),
                (this.popupThumbs = this.pswpElement.querySelectorAll(`${_} > *`)),
                this.popupThumbs.forEach((t, e) => {
                    t.addEventListener("click", (i) => {
                        i.preventDefault(),
                            t.parentElement.querySelector(`.${B}`).classList.remove(B),
                            t.classList.add(B),
                            this.popup.goTo(e);
                    });
                }),
                this.popup.listen("imageLoadComplete", () => this.setCurrentThumb()),
                this.popup.listen("beforeChange", () => this.setCurrentThumb()));
        }
        stopDisabledScroll(t) {
            t.stopPropagation();
        }
        onClose() {
            const t = this.pswpElement.querySelector(M);
            if ((t && t.parentNode.removeChild(t), this.popupThumbsContainer && this.popupThumbsContainer.firstChild))
                for (; this.popupThumbsContainer.firstChild; )
                    this.popupThumbsContainer.removeChild(this.popupThumbsContainer.firstChild);
            this.pswpElement.setAttribute(F, "");
            const e = this.pswpElement.querySelector(`.${O}`);
            e && this.pswpElement.removeChild(e),
                this.a11y.removeTrapFocus(),
                null !== theme.a11yTrigger && theme.a11yTrigger.focus(),
                this.closeBtn.removeEventListener("click", this.closeButtonClick);
        }
        setCurrentThumb() {
            const t = this.pswpElement.querySelector(`${_} > .${B}`);
            if ((t && t.classList.remove(B), !this.popupThumbs)) return;
            const e = this.popupThumbs[this.popup.getCurrentIndex()];
            e.classList.add(B), this.scrollThumbs(e);
        }
        scrollThumbs(t) {
            const e = this.popupThumbsContainer.scrollLeft + this.popupThumbsContainer.offsetWidth,
                i = t.offsetLeft;
            if (e <= i + t.offsetWidth || e > i) {
                const e = parseInt(window.getComputedStyle(t).marginLeft);
                this.popupThumbsContainer.scrollTo({ top: 0, left: i - e, behavior: "smooth" });
            }
        }
    }
    const H = "[data-product-slideshow]",
        U = "[data-zoom-wrapper]",
        R = "data-image-width",
        X = "data-image-height",
        G = "data-lightbox",
        Q = "pswp-zoom-gallery",
        Y = "pswp-zoom-gallery--single",
        J = "is-moving";
    class K {
        constructor(t) {
            (this.container = t.container),
                (this.slideshow = this.container.querySelector(H)),
                (this.zoomWrappers = this.container.querySelectorAll(U)),
                (this.zoomEnable = "true" === this.container.getAttribute(G)),
                this.zoomEnable && this.init();
        }
        init() {
            this.zoomWrappers.length &&
                this.zoomWrappers.forEach((t, e) => {
                    t.addEventListener("click", (i) => {
                        i.preventDefault();
                        const s = this.slideshow && this.slideshow.classList.contains(J);
                        (theme.a11yTrigger = t), s || this.createZoom(e);
                    }),
                        t.addEventListener("keyup", (e) => {
                            "Enter" === e.code && (e.preventDefault(), t.dispatchEvent(new Event("click")));
                        });
                });
        }
        createZoom(t) {
            const e = this;
            let i = [],
                s = 0;
            this.zoomWrappers.forEach((n) => {
                const o = n.getAttribute("href"),
                    r = parseInt(n.getAttribute(R)),
                    l = parseInt(n.getAttribute(X));
                if ((i.push({ src: o, w: r, h: l, msrc: o }), (s += 1), e.zoomWrappers.length === s)) {
                    let e = `${Q}`;
                    1 === s && (e = `${Q} ${Y}`);
                    new j(i, {
                        barsSize: { top: 0, bottom: "auto" },
                        history: !1,
                        focus: !1,
                        index: t,
                        mainClass: e,
                        showHideOpacity: !0,
                        showAnimationDuration: 250,
                        hideAnimationDuration: 250,
                        closeOnScroll: !1,
                        closeOnVerticalDrag: !1,
                        captionEl: !1,
                        closeEl: !0,
                        closeElClasses: ["caption-close"],
                        tapToClose: !1,
                        clickToCloseNonZoomable: !1,
                        maxSpreadZoom: 2,
                        loop: !0,
                        spacing: 0,
                        allowPanToNext: !0,
                        pinchToClose: !1,
                    });
                }
            });
        }
    }
    const Z = "html5",
        tt = "youtube",
        et = "[data-deferred-media]",
        it = "[data-deferred-media-button]",
        st = "[data-product-single-media-wrapper]",
        nt = "[data-video]",
        ot = "data-media-id",
        rt = "media--hidden";
    theme.mediaInstances = {};
    class lt {
        constructor(t) {
            (this.section = t), (this.container = t.container), (this.id = t.id), (this.players = {}), this.init();
        }
        init() {
            this.container.querySelectorAll(nt).forEach((t) => {
                const e = t.querySelector(it);
                e && e.addEventListener("click", this.loadContent.bind(this, t));
            });
        }
        loadContent(t) {
            if (t.querySelector(et).getAttribute("loaded")) return;
            const e = document.createElement("div");
            e.appendChild(t.querySelector("template").content.firstElementChild.cloneNode(!0));
            const i = t.dataset.mediaId,
                s = e.querySelector("video, iframe"),
                n = this.hostFromVideoElement(s),
                o = t.querySelector(et);
            o.appendChild(s).focus(),
                o.setAttribute("loaded", !0),
                (this.players[i] = {
                    mediaId: i,
                    sectionId: this.id,
                    container: t,
                    element: s,
                    host: n,
                    ready: () => {
                        this.createPlayer(i);
                    },
                });
            const r = this.players[i];
            switch (r.host) {
                case Z:
                    this.loadVideo(r, Z);
                    break;
                case tt:
                    window.isYoutubeAPILoaded
                        ? this.loadVideo(r, tt)
                        : D({ url: "https://www.youtube.com/iframe_api" }).then(() => this.loadVideo(r, tt));
            }
        }
        hostFromVideoElement(t) {
            return "VIDEO" === t.tagName
                ? Z
                : "IFRAME" === t.tagName &&
                    /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(t.src)
                  ? tt
                  : null;
        }
        loadVideo(t, e) {
            t.host === e && t.ready();
        }
        createPlayer(t) {
            const e = this.players[t],
                i = e.container.dataset.enableVideoLooping;
            switch (e.host) {
                case Z:
                    e.element.play(),
                        e.element.addEventListener("play", () => {
                            this.pauseOtherMedia(t);
                        }),
                        e.container.addEventListener("theme:media:hidden", (t) => this.onHidden(t)),
                        e.container.addEventListener("theme:xr-launch", (t) => this.onHidden(t)),
                        e.container.addEventListener("theme:media:visible", (t) => this.onVisible(t)),
                        this.observeVideo(e);
                    break;
                case tt:
                    if (e.host == tt && e.player) return;
                    YT.ready(() => {
                        const s = e.container.dataset.videoId;
                        (this.players[t].player = new YT.Player(e.element, {
                            videoId: s,
                            events: {
                                onReady: (t) => {
                                    t.target.playVideo();
                                },
                                onStateChange: (e) => {
                                    0 === e.data && i && e.target.seekTo(0),
                                        1 === e.data && this.pauseOtherMedia(t),
                                        e.data;
                                },
                            },
                        })),
                            (window.isYoutubeAPILoaded = !0),
                            e.container.addEventListener("theme:media:hidden", (t) => this.onHidden(t)),
                            e.container.addEventListener("theme:xr-launch", (t) => this.onHidden(t)),
                            e.container.addEventListener("theme:media:visible", (t) => this.onVisible(t)),
                            this.observeVideo(e);
                    });
            }
        }
        observeVideo(t) {
            new IntersectionObserver(
                (e, i) => {
                    e.forEach((e) => {
                        1 != e.intersectionRatio ? this.pauseVideo(t) : this.playVideo(t);
                    });
                },
                { threshold: 1 }
            ).observe(t.element);
        }
        playVideo(t) {
            t.player && t.player.playVideo ? t.player.playVideo() : t.element && t.element.play && t.element.play();
        }
        pauseVideo(t) {
            t.player && t.player.pauseVideo ? t.player.pauseVideo() : t.element && t.element.pause && t.element.pause();
        }
        onHidden(t) {
            if (void 0 !== t.target.dataset.mediaId) {
                const e = t.target.dataset.mediaId,
                    i = this.players[e];
                this.pauseVideo(i);
            }
        }
        onVisible(t) {
            if (void 0 !== t.target.dataset.mediaId) {
                const e = t.target.dataset.mediaId,
                    i = this.players[e];
                this.playVideo(i);
            }
        }
        pauseOtherMedia(t) {
            const e = `[${ot}="${t}"]`,
                i = document.querySelector(`${st}${e}`),
                s = document.querySelectorAll(`${st}:not(${e})`);
            i.classList.remove(rt),
                s.length &&
                    s.forEach((t) => {
                        t.dispatchEvent(new CustomEvent("theme:media:hidden")), t.classList.add(rt);
                    });
        }
    }
    theme.mediaInstances = {};
    class at {
        constructor(t) {
            (this.section = t), (this.id = t.id), (this.container = t.container);
        }
        init() {
            new lt(this.section), new K(this.section), new k(this.section);
        }
    }
    customElements.get("product-images") ||
        customElements.define(
            "product-images",
            class extends HTMLElement {
                constructor() {
                    super();
                }
                connectedCallback() {
                    const t = {
                        id: this.closest("product-info").id,
                        container: this.closest("product-info"),
                        type: "product",
                    };
                    (theme.mediaInstances[this.id] = new at(t)), theme.mediaInstances[this.id].init();
                }
            }
        );
})();
